/**
 * AnelProgresso — donut SVG de progresso (Produção v2).
 *
 * Elemento-assinatura dos cards de ambiente (brief 0.9): anel, NUNCA barra
 * linear. Geometria canônica do componente aprovado pela gestora
 * ("Componente - Card de Ambiente (PharuERP).html"): viewBox 36×36, r=15,
 * circunferência 94.25; para P% o arco é stroke-dasharray
 * "(P/100*94.25) 94.25", rotacionado -90° (começa no topo).
 *
 * Cores via tokens do tema (dark mode automático):
 *   trilho  #E9EBF2 -> var(--surface-3)
 *   arco/％ #5B5BF6 -> var(--accent)
 *
 * Props:
 * @param {object}  props
 * @param {number}  props.pct    Percentual 0–100 (clampado).
 * @param {number}  [props.size=30]   Lado do SVG em px (compact usa 26).
 * @param {number}  [props.stroke=3.2] Espessura do traço (compact usa 3.4).
 * @param {string}  [props.titulo] Rótulo acessível opcional.
 */
import React from "react";

const CIRCUNFERENCIA = 94.25; // 2π·15, valor travado no componente aprovado

function AnelProgresso({ pct = 0, size = 30, stroke = 3.2, titulo }) {
  const clamped = Math.max(0, Math.min(100, Number(pct) || 0));
  const arco = ((clamped / 100) * CIRCUNFERENCIA).toFixed(1);
  // No aprovado o font-size é em unidades do viewBox: 11 no card compacto
  // (svg 26px), 10 no completo (svg 30px).
  const fontSize = size <= 26 ? 11 : 10;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      role="img"
      aria-label={titulo || `${Math.round(clamped)}% concluído`}
    >
      <circle
        cx="18"
        cy="18"
        r="15"
        fill="none"
        stroke="var(--surface-3)"
        strokeWidth={stroke}
      />
      <circle
        cx="18"
        cy="18"
        r="15"
        fill="none"
        stroke="var(--accent)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${arco} ${CIRCUNFERENCIA}`}
        transform="rotate(-90 18 18)"
      />
      <text
        x="18"
        y="22"
        textAnchor="middle"
        fontSize={fontSize}
        fontWeight="600"
        fill="var(--accent)"
      >
        {Math.round(clamped)}%
      </text>
    </svg>
  );
}

export default AnelProgresso;
